import { BareActionContext } from 'vuex-typex'
import { ConvoState } from '../state'
import { RootState } from '../..'
import { ConvoService } from '../../../service/ConvoService'
import convoStore from '../convo-store'
import convoUtils from './convo-utils'
import { IConvo } from '../../../model/convo'
import { Meta } from '../../../model/meta'
import { IUser } from '../../../model/user'
import { IComment } from '../../../model/comment'
import commentStore from '../../comment/comment-store'
import authStore from '../../auth/auth-store'

export default async function setCommentJybedForUser(context: BareActionContext<ConvoState, RootState>, payload: { convo: IConvo, comment: IComment })
{
  if (payload.convo.meta) {
    commentStore.commitSetIsAllJybed({ comment: payload.comment, isAllJybed: payload.convo.meta.isAllJybed })
  }

  return
}
